module.exports = __webpack_public_path__ + "img/box-sign.bc0672de.svg";